module.exports = __webpack_public_path__ + "static/media/4-2.527f0c75.mp3";